import { UpgradeTokenResponse } from '@/types/api/mypage/UpgradeTokenInfo';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

/** 10Gアップグレード用トークン取得APIのURL */
const url = ApiUrl.Read.UPGRADE_TOKEN;

/**
 * 10Gアップグレード用トークン取得APIの呼び出しフック。
 * 外部申込導線や次画面へ安全に引き継ぐためのトークンを取得する。
 *
 * @returns execute - API実行関数
 */
const useGetUpgradeToken = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<UpgradeTokenResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetUpgradeToken;
